import throttle from "lodash/throttle";
import debounce from "lodash/debounce";

const SELECTORS = {
  generalFooter: ".global-footer__wrapper",
};

const CLASSES = {
  hide: "sticky-footer--hide",
  reveal: "sticky-footer--reveal",
  spacing: "sticky-footer--spacing",
};

class StickyFooter {
  constructor(context) {
    this.context = context;
    this.mainFooter = document.querySelector(SELECTORS.generalFooter);
    this.lastScrollPosition = 0;
    this.showSticky = false;
  }

  init() {
    this.stickyRevealHandler = this.handleStickyReveal.bind(this);
    this.subscribe();
  }

  subscribe() {
    window.addEventListener("load", () => {
      // The domFooter method set the sticky footer just after the main footer region
      this.domFooter(this.context, this.mainFooter);
      window.requestIdleCallback(this.stickyRevealHandler);
    });

    window.addEventListener(
      "scroll",
      throttle(() => {
        window.requestIdleCallback(this.stickyRevealHandler);
      }),
      300,
      {
        leading: true,
        trailing: false,
      },
    );

    window.addEventListener(
      "scroll",
      debounce(() => {
        window.requestIdleCallback(this.stickyRevealHandler);
      }),
      400,
      {
        leading: false,
        trailing: true,
      },
    );
  }

  domFooter(footerNode, referenceElement) {
    referenceElement.classList.add(CLASSES.spacing);
    referenceElement.parentNode.insertBefore(
      footerNode,
      referenceElement.nextSibling,
    );
  }

  hide() {
    if (this.context.classList.contains(CLASSES.reveal)) {
      // Only trigger hide animation if nav was previously revealed
      this.context.classList.remove(CLASSES.hidden, CLASSES.reveal);
      this.context.classList.add(CLASSES.hide);
    }

    return this;
  }

  reveal() {
    this.context.classList.remove(CLASSES.hidden, CLASSES.hide);
    this.context.classList.add(CLASSES.reveal);

    return this;
  }

  handleStickyReveal() {
    const currentScrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;

    // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
    if (currentScrollPosition < 0) {
      return;
    }

    if (
      currentScrollPosition === this.lastScrollPosition ||
      Math.abs(currentScrollPosition - this.lastScrollPosition) < 1
    ) {
      return;
    }

    const isScrollingDown = currentScrollPosition > this.lastScrollPosition;
    const isInitScrolled = this.lastScrollPosition === 0;
    this.showSticky = isScrollingDown || isInitScrolled;

    window.requestAnimationFrame(() => {
      if (this.showSticky) {
        this.reveal();
      } else {
        this.hide();
      }

      this.setLastScrollPosition(currentScrollPosition);
    });
  }

  setLastScrollPosition(scrollPosition) {
    this.lastScrollPosition = scrollPosition;

    return this;
  }
}

export { StickyFooter };
